module.exports = __webpack_public_path__ + "img/P150T_weapon_113.29e3dd94.png";